module.exports = "/_next/static/images/projectsEnergy2-a0c57ae82ece63c2a52100e4f3e0a34c.webp";